import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useGlobalContext } from '../../../../context/ContextGlobal'
import {
  addSubDocument,
  getDocument,
  getDocuments,
  getSubDocuments,
  setSubDocument,
  updateDocument,
  updateSubDocument,
} from '../../../../firebase/firestore'
import { CreateSearchField } from '../../../../utils/createSeachField'
import { DateNow, DateTimeNow } from '../../../../utils/dates'
import { ExportAllStaffPayment } from '../../../../utils/exportToExcel'
import { TryCatch } from '../../../../utils/general'
import { DeleteValueInArrayOfObject } from '../../../../utils/handlingArrays'
import { SetHistoryEvent } from '../../../../utils/requests'
import { sendNotification } from '../../../../utils/sendNotification'
import { HandleExportPaymentSheet } from '../_spreadsheets/exportPaymentSheet'
import { FilteredQuery } from '../_utils/filteredQuery'
import { statusStaff } from '../_utils/statusCandidate'

export const useClientEventsFinally = () => {
  const {
    user,
    setAlerts,
    loading,
    setLoading,
    dataContext,
    setDataContext,
    infosContext,
    setInfosContext,
    formContext,
    setFormContext,
    statusLoading,
    setStatusLoading,
  } = useGlobalContext()

  const { id } = useParams()
  const navigate = useNavigate()

  const [page, setPage] = useState(0)
  const [filter, setFilter] = useState({ date: 'todos', round: 'todos', positionName: 'todos', status: 'todos' })
  const [modalSelectCandidacy, setModalSelectCandidacy] = useState(false)
  const [modalSelectCandidacySelected, setModalSelectCandidacySelected] = useState(false)

  // ✅ Guard para evitar execução duplicada/loop
  const isProcessing = useRef(false)

  const clientId = user.client.id

  // ✅ Sanitização profunda: remove undefined/null de objetos e arrays recursivamente
  const deepSanitize = (value) => {
    if (Array.isArray(value)) {
      return value.map((item) => deepSanitize(item)).filter((item) => item !== undefined && item !== null)
    }
    if (value !== null && typeof value === 'object') {
      return Object.fromEntries(
        Object.entries(value)
          .filter(([_, v]) => v !== undefined && v !== null)
          .map(([k, v]) => [k, deepSanitize(v)]),
      )
    }
    return value
  }

  const getAllStaff = async () => {
    const getStaff = await getSubDocuments('events', id, 'staff')
    const getJobOffers = await getSubDocuments('events', id, 'jobOffers')
    const getPositions = await getDocuments('cargos')

    const staffEnriched = getStaff.map((staff) => {
      const { idJobOffers } = staff
      const jobOfferData = getJobOffers.find((key) => key.id === idJobOffers)

      if (!jobOfferData) {
        return { ...staff, position: null, jobOffer: null }
      }

      const position = (getPositions || []).find((pos) => pos.id === jobOfferData.idPosition)

      return {
        ...staff,
        jobOffer: { ...jobOfferData, position },
      }
    })
    return staffEnriched
  }

  const getDatas = async ({ query = null, pageQuery = null } = {}) => {
    setFilter((prev) => ({ ...prev, search: '' }))
    await setDataContext({})
    const getStaff = await getAllStaff()
    setDataContext(getStaff)
    return getStaff
  }

  const validateFilter = (value, field, returnType = 'string') => {
    if (value?.[field] === 'todos' || value?.[field] === null) {
      return 'todos'
    } else {
      switch (returnType) {
        case 'string':
          return String(value?.[field])
        case 'number':
          return Number(value?.[field])
        default:
          return value?.[field]
      }
    }
  }

  const validateIdJobOffersByFilter = (filters) => {
    const datesByQuery = new Set()
    const positionsByQuery = new Set()
    const roundByQuery = new Set()

    Object.values(infosContext?.jobOffers).forEach((jobOffer) => {
      if (filters?.date && jobOffer.date === filters?.date && jobOffer.date !== 'todos') {
        datesByQuery.add(jobOffer.id)
      }
      if (filters?.position && jobOffer.idPosition === filters?.position && jobOffer.idPosition !== 'todos') {
        positionsByQuery.add(jobOffer.id)
      }
      if (filters?.round && jobOffer.round === filters?.round && jobOffer.round !== 'todos') {
        roundByQuery.add(jobOffer.id)
      }
    })

    let idJobOffers = []

    if (datesByQuery.size === 0 && positionsByQuery.size === 0 && roundByQuery.size === 0) {
      idJobOffers = []
    } else if (datesByQuery.size === 0 && positionsByQuery.size === 0) {
      idJobOffers = Array.from(roundByQuery)
    } else if (datesByQuery.size === 0 && roundByQuery.size === 0) {
      idJobOffers = Array.from(positionsByQuery)
    } else if (positionsByQuery.size === 0 && roundByQuery.size === 0) {
      idJobOffers = Array.from(datesByQuery)
    } else {
      idJobOffers = Array.from(datesByQuery)
        .filter((id) => positionsByQuery.size === 0 || positionsByQuery.has(id))
        .filter((id) => roundByQuery.size === 0 || roundByQuery.has(id))
    }

    return idJobOffers
  }

  const queryData = async () => {
    const type = formContext?.typeSelectCandidacy
    const date = validateFilter(filter, 'date')
    const position = validateFilter(filter, 'idPosition')
    const round = validateFilter(filter, 'round')
    let status = filter?.status === 'todos' ? null : Number(filter?.status)

    if (type === 'debts' || type === 'favorite') {
      if (status === null) {
        status = [7, 9, 10]
      } else if (status !== 7 && status !== 9 && status !== 10) {
        status = 7
        setFilter((prev) => ({ ...prev, status: 7 }))
        setAlerts((prev) => [
          ...prev,
          {
            type: 'error',
            title: 'Pesquisa somente check-out realizados',
            msg: 'Não é possível pesquisar candidaturas que ainda não completaram o processo de check-out',
          },
        ])
      }
    }
    if (type === 'blocked') {
      if (status === null) {
        status = [0, 1, 2, 3, 4, 5, 6, 8, 11]
      } else if (status === 7 || status === 9 || status === 10) {
        status = [0, 1, 2, 3, 4, 5, 6, 8, 11]
        setFilter((prev) => ({ ...prev, status: 'todos' }))
        setAlerts((prev) => [
          ...prev,
          {
            type: 'error',
            title: 'Bloqueio de pesquisa',
            msg: 'Não é possível bloquear candidaturas que tenham completaram o processo de check-out',
          },
        ])
      }
    }

    const idJobOffers = validateIdJobOffersByFilter({ date, position, status, round })

    const query = {
      ...filter,
      status,
      idJobOffers,
    }
    const moreQuery = { date, idPosition: position, page: 1 }
    delete query.filtered
    const filteredQuery = FilteredQuery({ ...query, ...moreQuery })
    setFilter((prev) => ({ ...prev, search: '' }))

    await getDatas({ query: filteredQuery, pageQuery: 1 })
  }

  const getForm = async () => {
    let finallyEvent = await getSubDocuments('events', id, 'finally')
    finallyEvent = finallyEvent.filter((infos) => infos.id === 'infos')
    if (finallyEvent.length > 0) {
      finallyEvent = finallyEvent?.[0]
      delete finallyEvent.id
    }

    const statusFilter = [7, 9, 10]

    const getStaff = await getAllStaff()

    const newListReviews = (getStaff || [])
      .filter((staff) => statusFilter.includes(staff.status))
      .map((candidacy) => {
        if (!candidacy?.review) {
          return {
            id: candidacy?.id,
            uuid: candidacy?.uuid,
            idPosition: candidacy?.jobOffer?.idPosition,
            positionName: candidacy?.jobOffer?.position?.nome || candidacy?.jobOffer?.position?.name,
            name: candidacy?.name,
            cpf: candidacy?.cpf,
            status: statusStaff[Number(candidacy?.status)]?.status,
            rating: 5,
            comment: '',
          }
        }
        return null
      })
      .filter((item) => item !== null)
      .reduce((acc, item) => {
        if (!acc.some((obj) => obj.cpf === item.cpf)) {
          acc.push(item)
        }
        return acc
      }, [])

    setFormContext((prev) => ({ ...prev, list_reviews: newListReviews, ...finallyEvent, staff: getStaff }))
    setStatusLoading('')
  }

  const getInfos = async () => {
    const getJobOffers = await getSubDocuments('events', id, 'jobOffers')
    const getPositions = await getDocuments('cargos')
    const positionsById = getPositions.reduce((acc, curr) => {
      acc[curr.id] = curr.nome
      return acc
    }, {})
    const JobOffersById = getJobOffers.reduce((acc, curr) => {
      acc[curr.id] = { ...curr, positionName: positionsById[curr.idPosition] }
      return acc
    }, {})

    const dates = []
    const positions = []

    const getTeams = await getSubDocuments('clientes', clientId, 'teams')

    Object.values(JobOffersById).forEach((offer) => {
      if (!dates.includes(offer.date)) {
        dates.push(offer.date)
      }
      if (!positions.includes(offer.idPosition)) {
        positions.push(offer.idPosition)
      }
    })

    const filters = {
      dates,
      positions,
    }

    const newInfos = {
      positions: getPositions,
      positionsById,
      jobOffers: JobOffersById,
      filters,
      teams: getTeams,
    }

    setInfosContext((prev) => ({ ...prev, ...newInfos }))
  }

  const schemafinallyEvent = async (value) => {
    // ✅ Aplica deepSanitize em todo o schema antes de retornar
    const raw = {
      list_reviews: value?.list_reviews || [],
      list_debts: value?.list_debts || [],
      list_favorite: value?.list_favorite || [],
      list_blocked: value?.list_blocked || [],
      favoriteAll: value.favoriteAll || false,
      createNewTeams: value.createNewTeams || false,
      hasFavorites: value.hasFavorites || false,
      hasDebts: value.hasDebts || false,
      hasBlocked: value.hasBlocked || false,
      motivoDefaultBlocked: value?.motivoDefaultBlocked || '',
      nameTeams: value?.nameTeams || '',
    }
    return deepSanitize(raw)
  }

  const saveFinnalyInfoEvent = async () => {
    if (!user.user.permissions.finallyEvent_save) {
      setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Permissão Negada',
          msg: 'Você não possui permissão para realizar essa ação.',
        },
      ])
      return false
    }

    const newFinallyInfo = await schemafinallyEvent(formContext)
    await setSubDocument('events', id, 'finally', 'infos', newFinallyInfo)
    await SetHistoryEvent(id, user.user.nome, `Informações de finalização do evento salvas`)

    setAlerts((prev) => [
      ...prev,
      {
        type: 'success',
        title: 'Informações Salvas',
        msg: 'As informações de finalização foram salvas com sucesso na base de dados.',
      },
    ])
    return true
  }

  const finnalyStaff = async (hasDebts, getStaff, getJobOffers, newFinallyInfo) => {
    try {
      const roleStatusFinally = {
        0: { status: 1, reason: 'Sua candidatura não foi selecionada para este evento' },
        2: { status: 4, reason: 'Você não confirmou a presença no evento e perdeu 1 ponto no score' },
        3: { status: 6, reason: 'Você confirmou presença, mas não compareceu ao evento e perdeu 2 pontos no score' },
        5: { status: 8 },
        7: { status: 9 },
      }

      // ✅ Verifica checkouts pendentes e interrompe com false
      const checkoutOpen = getStaff.filter((candidacy) => candidacy.status === 5 || candidacy.status === 8)
      if (checkoutOpen.length > 0) {
        setAlerts((prev) => [
          ...prev,
          {
            type: 'error',
            title: 'Checkouts não Realizados',
            msg: 'Alguns colaboradores ainda não realizaram o checkout no evento. Por favor, verifique, conclua o checkout e tente novamente.',
          },
        ])
        return false
      }

      const promissesAdjustCandacys = getStaff.map(async (candidacy) => {
        const newStatus = roleStatusFinally[Number(candidacy?.status)] || {}
        const jobOffer = getJobOffers.find((job) => job.id === candidacy.idJobOffers)
        let financialHistory = []

        if (jobOffer) {
          const food = jobOffer?.food === '2' ? Number(jobOffer?.food_value) : 0
          const transportAllowance =
            jobOffer?.transportAllowance === '2' ? Number(jobOffer?.transportAllowance_value) : 0
          const rawValue = Number(jobOffer?.value) || 0
          const cache = rawValue - (food + transportAllowance)

          financialHistory = [{ value: cache, desc: 'Cachê', type: 'C' }]

          if (food > 0) {
            financialHistory.push({ value: food, desc: 'Vale Alimentação (incluso no Cachê)', type: 'C' })
          }

          if (transportAllowance > 0) {
            financialHistory.push({ value: transportAllowance, desc: 'Vale Transporte (incluso no Cachê)', type: 'C' })
          }
        }

        if (hasDebts) {
          const listDebt = newFinallyInfo?.list_debts || []
          listDebt
            .filter((infos) => infos.id === candidacy.id)
            .forEach((financial) => {
              financialHistory.push({
                value: Number(financial.valueDebt) || 0,
                desc: financial.motivoDebt || '',
                type: financial.typeDebt || 'D',
              })
            })
        }

        // ✅ deepSanitize no payload completo antes de salvar
        const newCandidacy = deepSanitize({
          status: newStatus.status ?? candidacy.status,
          ...(newStatus?.reason && { reason: newStatus.reason }),
          financialHistory,
        })

        await updateSubDocument('events', id, 'staff', candidacy.id, newCandidacy)
      })

      await Promise.all(promissesAdjustCandacys)

      setAlerts((prev) => [
        ...prev,
        {
          type: 'success',
          title: 'Staff Ajustada',
          msg: 'Todas as informações de ajuste e desconto foram registradas nas candidaturas com sucesso.',
        },
      ])
      return true
    } catch (e) {
      console.error('[finnalyStaff] ❌ Erro:', e)
      setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Erro ao finalizar Staff',
          msg: `Ocorreu um erro ao ajustar a staff: ${e?.message || 'Erro desconhecido'}`,
        },
      ])
      return false
    }
  }

  const favoriteStaff = async (hasFavorite, getStaff, eventInfos, newFinallyInfo) => {
    try {
      if (!hasFavorite) return true
      const favoriteAll = newFinallyInfo?.favoriteAll
      const createNewTeams = newFinallyInfo?.createNewTeams
      const nameTeams = newFinallyInfo?.nameTeams

      let promisseFavoriteAll
      const newTeam = []

      if (favoriteAll) {
        const processedUuids = new Set()

        const promiseFavoriteAll = getStaff.map(async (candidacy) => {
          const { uuid } = candidacy

          if (processedUuids.has(uuid)) return
          processedUuids.add(uuid)

          const collaborator = await getDocument('colaboradores', uuid)
          const newFavorite = {
            dt_assigned: DateTimeNow(),
            dt_created: DateTimeNow(),
            search: CreateSearchField(collaborator),
            uuid,
            status: true,
          }

          await setSubDocument('clientes', user.client.id, 'favorites', uuid, newFavorite)
          await setSubDocument('colaboradores', uuid, 'favorites', user.client.id, {
            dt_assigned: DateTimeNow(),
            dt_created: DateTimeNow(),
            idClient: user.client.id,
            status: false,
          })

          const collaboratorInfo = {
            cpf: collaborator.cpf,
            name: collaborator.name,
            search: CreateSearchField(collaborator),
            photoUrl: collaborator.photoUrl,
            uuid,
          }

          newTeam.push(collaboratorInfo)
        })

        await Promise.all(promiseFavoriteAll)
        setAlerts((prev) => [
          ...prev,
          { type: 'success', title: 'Staff Favoritada', msg: 'Staff favoritada com sucesso.' },
        ])
      } else {
        const listFavorite = newFinallyInfo?.list_favorite || []

        promisseFavoriteAll = listFavorite.map(async (candidacy) => {
          const uuid = candidacy.uuid
          const colaborator = await getDocument('colaboradores', uuid)

          await setSubDocument('clientes', user.client.id, 'favorite', uuid, {
            uuid,
            dt_created: DateTimeNow(),
            search: CreateSearchField(colaborator),
            status: false,
          })
          await setSubDocument('colaboradores', uuid, 'favorites', user.client.id, {
            idClient: user.client.id,
            dt_created: DateTimeNow(),
            dt_assigned: DateTimeNow(),
            status: true,
          })

          const collaboratorInfo = {
            cpf: colaborator.cpf,
            name: colaborator.name,
            search: CreateSearchField(colaborator),
            photoUrl: colaborator.photoUrl,
            uuid,
          }
          newTeam.push(collaboratorInfo)
        })

        await Promise.all(promisseFavoriteAll)
        setAlerts((prev) => [
          ...prev,
          { type: 'success', title: 'Lista de colaboradores Favoritada', msg: 'Lista de favoritos salva com sucesso.' },
        ])
      }

      if (createNewTeams) {
        const newTeamDocument = {
          teams: newTeam,
          createdBy: user.user.nome,
          description: `Criado na finalização do evento: ${eventInfos.name} - ${eventInfos.round} ás ${DateTimeNow()} pelo colaborador ${user.user.nome}`,
          dt_created: DateTimeNow(),
          name: nameTeams !== '' ? nameTeams : `Staff - ${eventInfos.name} - ${eventInfos.round} - ${DateNow()}`,
        }
        await addSubDocument('clientes', user.client.id, 'teams', newTeamDocument)
        setAlerts((prev) => [
          ...prev,
          { type: 'success', title: 'Nova Equipe Criada', msg: 'Criamos uma nova equipe com a staff desse evento.' },
        ])
      }
      return true
    } catch (error) {
      console.error('[favoriteStaff] ❌ Erro:', error)
      setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Erro ao favoritar Staff',
          msg: 'Ocorreu um erro ao favoritar colaboradores. Tente novamente.',
        },
      ])
      return false
    }
  }

  const blockedStaff = async (hasBlocked, eventInfos, newFinallyInfo) => {
    try {
      if (!hasBlocked) return true

      const listBlockeds = newFinallyInfo?.list_blocked || []
      const reasonDefault = newFinallyInfo?.motivoDefaultBlocked || ' '
      const uuidprocesseds = new Set()

      const promisseBlockedColaborator = listBlockeds.map(async (candidacy) => {
        const uuid = candidacy.uuid

        if (uuidprocesseds.has(uuid)) return
        uuidprocesseds.add(uuid)

        const newBlockedForClient = {
          dt_created: DateTimeNow(),
          createdBy: candidacy.createdBy || user.user.nome,
          reason: candidacy?.motivoBlocked || reasonDefault,
          uuid,
          search: CreateSearchField(candidacy),
          infoExtra: `Bloqueado pela finalização do evento ${eventInfos.name} - ${eventInfos.round} - ${eventInfos.id}`,
        }

        const newBlockedForColaborator = {
          dt_created: DateTimeNow(),
          createdBy: candidacy.createdBy || user.user.nome,
          reason: candidacy?.motivoBlocked || reasonDefault,
          clientId: user.client.id,
        }

        await setSubDocument('colaboradores', uuid, 'blockedIn', user.client.id, newBlockedForColaborator)
        await setSubDocument('clientes', user.client.id, 'blockeds', uuid, newBlockedForClient)
      })

      await Promise.all(promisseBlockedColaborator)
      setAlerts((prev) => [
        ...prev,
        {
          type: 'success',
          title: 'Colaboradores Bloqueados',
          msg: 'Lista de colaboradores foi bloqueada com sucesso.',
        },
      ])

      return true
    } catch (e) {
      console.error('[blockedStaff] ❌ Erro:', e)
      setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Erro ao bloquear Colaboradores',
          msg: 'Ocorreu um erro ao bloquear colaboradores. Tente novamente.',
        },
      ])
      return false
    }
  }

  const evaluateStaff = async (eventInfos, newFinallyInfo) => {
    try {
      const listReviews = newFinallyInfo?.list_reviews || []

      const promisseEvaluateCollaborators = listReviews.map(async (review) => {
        const newReview = deepSanitize({
          dt_created: DateTimeNow(),
          createdBy: user?.user?.nome || user?.user?.name,
          eventName: `${eventInfos.name} - ${eventInfos.round}`,
          idEvent: eventInfos.id,
          clientName: eventInfos.clientName,
          idPosition: review?.idPosition,
          positionName: review?.positionName,
          comment: review?.comment || '',
          rating: review?.rating,
          calculated: false,
        })

        const updateCandidacy = { review: true }

        await addSubDocument('colaboradores', review?.uuid, 'reviews', newReview)
        await updateSubDocument('events', eventInfos?.id, 'staff', review?.id, updateCandidacy)
      })

      await Promise.all(promisseEvaluateCollaborators)
      setAlerts((prev) => [
        ...prev,
        { type: 'success', title: 'Colaboradores Avaliados', msg: 'Lista de colaboradores avaliada com sucesso.' },
      ])

      return true
    } catch (e) {
      console.error('[evaluateStaff] ❌ Erro:', e)
      setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Erro ao avaliar Colaboradores',
          msg: 'Ocorreu um erro ao avaliar colaboradores. Tente novamente.',
        },
      ])
      return false
    }
  }

  const closeJobOffers = async (getJobOffers, eventInfos) => {
    try {
      const promisseEvaluateCollaborators = getJobOffers.map(async (job) => {
        await updateSubDocument('events', eventInfos?.id, 'jobOffers', job?.id, { status: 'closed' })
      })

      await Promise.all(promisseEvaluateCollaborators)
      setAlerts((prev) => [
        ...prev,
        { type: 'success', title: 'Vagas Fechadas', msg: 'As vagas cadastradas nesse evento foram fechadas.' },
      ])

      return true
    } catch (e) {
      console.error('[closeJobOffers] ❌ Erro:', e)
      setAlerts((prev) => [
        ...prev,
        { type: 'error', title: 'Erro ao fechar Vagas', msg: 'Ocorreu um erro ao fechar as vagas. Tente novamente.' },
      ])
      return false
    }
  }

  const finallyEvent = async () => {
    // ✅ Guard: impede execução duplicada/loop
    if (isProcessing.current) return
    isProcessing.current = true

    try {
      if (!user.user.permissions.finallyEvent_submit) {
        setAlerts((prev) => [
          ...prev,
          { type: 'error', title: 'Permissão Negada', msg: 'Você não possui permissão para realizar essa ação.' },
        ])
        return
      }

      const newFinallyInfo = await schemafinallyEvent(formContext)
      const hasDebts = newFinallyInfo.hasDebts
      const hasFavorites = newFinallyInfo.hasFavorites
      const hasBlocked = newFinallyInfo.hasBlocked

      setStatusLoading('Salvando Informações...')
      const savedInfo = await saveFinnalyInfoEvent()
      if (!savedInfo) return

      const getStaff = await getSubDocuments('events', id, 'staff')
      const eventInfos = await getDocument('events', id)
      const getJobOffers = await getSubDocuments('events', id, 'jobOffers')

      const staffUUID = getStaff.map((colab) => colab.uuid)

      let passed

      setStatusLoading('Finalizando Staff...')
      passed = await finnalyStaff(hasDebts, getStaff, getJobOffers, newFinallyInfo)
      if (!passed) return

      setStatusLoading('Favoritando Colaboradores...')
      passed = await favoriteStaff(hasFavorites, getStaff, eventInfos, newFinallyInfo)
      if (!passed) return

      setStatusLoading('Bloqueando Colaboradores...')
      passed = await blockedStaff(hasBlocked, eventInfos, newFinallyInfo)
      if (!passed) return

      setStatusLoading('Avaliando Colaboradores...')
      passed = await evaluateStaff(eventInfos, newFinallyInfo)
      if (!passed) return

      setStatusLoading('Fechando Vagas...')
      passed = await closeJobOffers(getJobOffers, eventInfos)
      if (!passed) return

      setStatusLoading('Salvando informações e enviando notificações...')
      const newFinally = { dtFinally: DateTimeNow(), finallyBy: user.user.nome }
      const newStatusEvent = 'closed'

      await updateDocument('events', id, { status: newStatusEvent, ...newFinally })
      setFormContext((prev) => ({ ...prev, statusEvent: newStatusEvent, ...newFinally }))

      const notificationFields = {
        title: 'Evento Fechado',
        description: `O evento "${eventInfos.name.toUpperCase()}" foi finalizado.`,
      }

      await sendNotification(staffUUID, [], notificationFields.title, notificationFields.description)

      setStatusLoading('Exportando Planilha de pagamento...')
      await HandleExportPaymentSheet(id, setLoading, setAlerts)
      await SetHistoryEvent(id, user.user.nome, `Evento Finalizado`)
    } finally {
      // ✅ Sempre limpa loading e libera o guard, independente de erro ou sucesso
      setStatusLoading('')
      setLoading(false)
      isProcessing.current = false
    }
  }

  const schemaCandidacy = (candidacy, save) => {
    if (save) return candidacy

    return {
      id: candidacy.id,
      uuid: candidacy.uuid,
      name: candidacy.name,
      cpf: candidacy.cpf,
      positionName: candidacy.positionName,
      date: candidacy.date,
      idJobOffers: candidacy.idJobOffers,
      createdBy: user.user.nome,
    }
  }

  const SelectCandidacy = async (candidacy, save = false, returnAction = false) => {
    const newCandidacy = schemaCandidacy(candidacy, save)
    const type = formContext?.typeSelectCandidacy
    if (type !== '' && type !== undefined) {
      const field = `list_${type}`

      if (type === 'debts' && save === false) {
        if (candidacy.status < 7 || candidacy.status > 10) {
          return setAlerts((prev) => [
            ...prev,
            {
              type: 'error',
              title: 'Seleção bloqueada',
              msg: 'Não é possível selecionar ajustes/descontos para candidaturas que ainda não completaram o processo de check-out.',
            },
          ])
        }

        setModalSelectCandidacy(false)
        setModalSelectCandidacySelected(true)

        return setFormContext((prev) => ({
          ...prev,
          candidacySelected: candidacy,
        }))
      }

      setModalSelectCandidacy(false)
      setModalSelectCandidacySelected(false)

      if (save && returnAction) {
        setModalSelectCandidacy(true)
      }

      return setFormContext((prev) => {
        const currentList = prev?.[field] || []
        const index = currentList.length

        return {
          ...prev,
          [field]: [{ ...newCandidacy, index }, ...currentList],
        }
      })
    }
  }

  const DeleteCandidacy = async (index, field) => {
    setFormContext((prev) => {
      const newlist = DeleteValueInArrayOfObject(prev?.[field], 'index', index)
      return { ...prev, [field]: [...newlist] }
    })
  }

  const DuplicateCandidacy = async (candidacy, field) => {
    setFormContext((prev) => {
      const currentList = prev?.[field] || []
      const index = currentList.length

      return {
        ...prev,
        [field]: [...currentList, { ...candidacy, index }],
      }
    })
  }

  const FetchGetDatas = async (page) => {
    await TryCatch(
      () => {
        getDatas({ query: filter, pageQuery: page })
      },
      setLoading,
      setAlerts,
    )
  }

  const FetchGetForm = async () => {
    await TryCatch(getForm, setLoading, setAlerts)
  }

  const FetchGetDatasQuery = async () => {
    await TryCatch(queryData, setLoading, setAlerts)
  }

  const FetchGetInfos = async () => {
    await TryCatch(getInfos, setLoading, setAlerts)
  }

  const HandleFinallyEvents = async () => {
    await TryCatch(finallyEvent, setLoading, setAlerts)
  }

  const HandleSaveFinallyInfoEvent = async () => {
    await TryCatch(saveFinnalyInfoEvent, setLoading, setAlerts)
  }

  const HandleExportExcelPayment = async () => {
    if (!user.user.permissions.staffEvent_exportPayment) {
      return setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          title: 'Permissão Negada',
          msg: 'Você não possui permissão para realizar essa ação.',
        },
      ])
    }
    await TryCatch(
      async () => {
        await ExportAllStaffPayment(id, setAlerts)
      },
      setLoading,
      setAlerts,
    )
    await SetHistoryEvent(id, user.user.nome, `Planilha de Pagamentos extraida`)
  }

  useEffect(() => {
    const updateContexts = async () => {
      await setDataContext({})
      await setInfosContext({})
      await FetchGetInfos()
      await FetchGetForm()
    }
    updateContexts()
  }, [])

  useEffect(() => {
    if (page > 0) {
      FetchGetDatas(page)
    }
  }, [page])

  useEffect(() => {
    setDataContext([])
    setFilter((prev) => ({ ...prev, date: 'todos', idPosition: 'todos', status: 'todos', round: 'todos', search: '' }))
  }, [modalSelectCandidacy])

  useEffect(() => {
    const search = filter?.search
    if (search !== undefined && search !== '') {
      const dataContextList = dataContext?.data || []

      const currentFilter = String(search).toLowerCase().trim()
      const newDataFiltered = dataContextList.filter((data) => {
        const line = `${data?.name} || ${data?.cpf}`.toLowerCase().trim()
        return line.includes(currentFilter)
      })

      setDataContext((prev) => ({
        ...prev,
        dataFiltered: newDataFiltered,
      }))
    }
  }, [filter])

  return {
    clientId,
    navigate,
    loading,
    filter,
    setFilter,
    setFormContext,
    modalSelectCandidacy,
    setModalSelectCandidacy,
    dataContext,
    formContext,
    infosContext,
    FetchGetDatas,
    FetchGetInfos,
    FetchGetDatasQuery,
    page,
    setPage,
    SelectCandidacy,
    DuplicateCandidacy,
    DeleteCandidacy,
    HandleFinallyEvents,
    HandleSaveFinallyInfoEvent,
    statusLoading,
    HandleExportExcelPayment,
    modalSelectCandidacySelected,
    setModalSelectCandidacySelected,
  }
}
